import { PRODUCTION_STATE_LABELS, PRODUCTION_STATE_VALUES, type ProductionState } from "@storyline/shared";

type PipelineStepperProps = {
	current: ProductionState;
};

const PipelineStepper: React.FC<PipelineStepperProps> = ({ current }) => {
	const currentIndex = PRODUCTION_STATE_VALUES.indexOf(current);

	return (
		<div className="flex flex-wrap gap-2 overflow-x-auto">
			{PRODUCTION_STATE_VALUES.map((state, index) => {
				const done = index < currentIndex;
				const active = index === currentIndex;
				const tone = active
					? "border-accent-lav bg-accent-soft text-accent-lav"
					: done
						? "border-success/40 text-success"
						: "border-border-soft text-muted";
				return (
					<span key={state} className={`flex items-center gap-1.5 rounded-full border px-3 py-1 font-semibold text-xs ${tone}`}>
						<span className="opacity-70">{index + 1}</span>
						{PRODUCTION_STATE_LABELS[state]}
					</span>
				);
			})}
		</div>
	);
};

export default PipelineStepper;
